<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
     <validation-observer ref="observer" v-slot="{ handleSubmit }">
    <b-form @submit.stop.prevent="handleSubmit(generar)">
             <b-row>
        <b-col class="subtitulos ml-2">
        BITACORA LOGIN PORTAL COMERCIAL
        </b-col>
      </b-row>
          <b-row class="mb-4">
            <b-col>
              <b-row>
                <b-col cols="4">
                  <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de inicio:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha inicio"
                                        :max="new Date()"
                                        @input="fechaMaxima($event)"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

                <b-col cols="4">
                  <validation-provider name="fcFinVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de fin:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha fin"
                                          v-model="filtro.fechaFin"
                                         :max="fechaInicioAux.addDays(diasMaximoMes) > new Date() ? new Date(): fechaInicioAux.addDays(diasMaximoMes)"
                                         :min="fechaInicioAux"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>
                      <b-col class="text-right col-2 mt-4">
                  <b-button
                      variant="outline-primary"
                      :disabled="loader"
                      @click="obtenerDatos()"
                  >
                    <span v-if="!loader">Buscar</span>
                    <span v-else>
                  <b-spinner small></b-spinner>
                  Buscando...
                </span>
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
      <b-col cols="12">
          <download-excel
            v-if="datosTabla.length > 0 && $localStorageService.can('Rep_bitac_login_portal_excel')"
            class="btn btn-primary"
            :data="datosTabla"
            :fields="fieldsExcel"
            worksheet="GestionVentas"
            name="Reporte de Bitacora Login Portal Comercial.xls"
        >
          Generar Excel
          <em class="fa fa-file-excel-o"></em>
        </download-excel>
      </b-col>
          </b-row>
        </b-form>
        </validation-observer>
          <b-row>
        <b-col cols="12">
          <b-table
            thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual"
              responsive
              class="parrafos"
          >
          <template v-slot:cell(respuesta)="row">
             <b-badge variant="success" v-if="row.item.respuesta === 'approved'">{{row.item.respuesta}}</b-badge>
             <b-badge variant="danger" v-else>{{row.item.respuesta}}</b-badge>
          </template>
         <template v-slot:cell(Pacientes)="row">
                <b-button size="sm" @click="row.toggleDetails">
                  {{ row.detailsShowing ? "Ocultar" : "Ver más" }}
                </b-button>
          </template>
        <template #row-details="row">
        <b-card>
          <span v-if="row.item.pacientes !== null">
               <ul v-for="item in row.item.pacientes" :key="item.nombre">
                   <li><strong>Nombre:</strong>{{item.nombre}}  <strong>Plan:</strong>{{item.plan}}</li>
               </ul>
          </span>
          <span v-else>
             <b-alert show variant="warning">No hay Pacientes</b-alert>
          </span>
        </b-card>
      </template>
          </b-table>
         <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla!==undefined && datosTabla.length === 0" variant="warning" show>No hay datos
            </b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="tabla"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>
        </div>
</template>

<script>
export default {
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
    datosTabla: [],
      fields: [],
      registrosPorPagina: 10,
      paginaActual: 0,
      loader: false,
      filtro: {
        fechaInicio: new Date(),
        fechaFin: null
      },
      hoy: new Date(),
      diasMaximoMes: null,
      fieldsExcel: {
        "Usuario": "usuario",
        "Evento Sistema": "evento",
        "Navegador Usuario":"navegador",
        "Fecha Entrada": "fecha"
      }, 
      fechaInicioAux: new Date()
    }
    },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
    mounted() {
    this.fields = [
      {key: "usuario", label: "Usuario", sortable: true},
      {key: "evento", label: "Evento Sistema", sortable: true},
      {key: "navegador", label: "Navegador Usuario", sortable: true},
      {key: "fecha", label: "Fecha Entrada", sortable: true}
    ];
  },
  methods:{
      obtenerDatos() {
        let fechaActual = this.$moment(this.filtro.fechaInicio).format("YYYY-MM-DD");
        let fechaF = this.$moment(this.filtro.fechaFin).format("YYYY-MM-DD");
      this.loader = true;
      this.datosTabla = [];
      const filtro = {
          "fechaInicio": fechaActual,
          "fechaFin": fechaF,
          "horas": this.$horas(),
          "idCanalOrigen":24
        };
        this.$http
            .post(this.$api +'reportes/bitacora/logeo', filtro)
            .then(respuesta => {
              if (respuesta.data.data) {
                if (respuesta.data.data !== undefined) {
                  this.datosTabla = respuesta.data.data;
                }
              }
            }).finally(() => {
          this.loader = false;
          this.paginaActual = 0;
        })
    },
    fechaMaxima(event){
      this.diasMaximoMes = this.$moment(event).daysInMonth();
      this.fechaInicioAux = new Date(event);
      this.filtro.fechaInicio = event;
      this.filtro.fechaFin = null;
      
    },
  }
}
</script>

<style>

</style>



